module.exports = __webpack_public_path__ + "img/Icon awesome-angle-right.abd97eb5.svg";